<div class="sheet-content">
  <h3 style="font-size:16px; margin-bottom: 25px;">Edit {{ data.recipient.name }}</h3>

  <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>

  <div class="sheet-actions">
    <button mat-button type="button" (click)="onCancel()" [disabled]="saving">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onSave()"
      [disabled]="form.invalid || saving"
    >
      {{ saving ? 'Saving…' : 'Save' }}
    </button>
  </div>

  <p class="sheet-error" *ngIf="error">{{ error }}</p>
</div>